module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("krLe8"))).then(() => parcelRequire('1iHdE'));